import { useTranslation } from "~/hooks/useTranslation";
import { ELanguage, ENameSpace } from "~/i18n/@types/types";

export function WelcomeMessage() {
  const {
    t,
    i18n: { language },
  } = useTranslation([ENameSpace.Login] as const);

  const isKo = language === ELanguage.Ko;

  return (
    <div className="space-y-3 text-center text-ciety-wh">
      <span className="typo-book-14">
        {t(`${ENameSpace.Login}:Root.Description`)}
      </span>
      <div className="flex items-center justify-center">
        {!isKo && (
          <span className="typo-medium-28">
            {t(`${ENameSpace.Login}:Root.WelcomeToThe`)}
          </span>
        )}
        <span className="typo-medium-30">
          {t(`${ENameSpace.Login}:Root.Ciety`)}
        </span>
        {isKo && (
          <span className="typo-medium-28">
            {t(`${ENameSpace.Login}:Root.WelcomeToThe`)}
          </span>
        )}
      </div>
    </div>
  );
}
